import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import LenderHeroSection from './LenderHeroSection';
import PartnerSection from './LendingPartnerSection'; 
import LenderFormSection from './LenderFormSection';                  

const LenderPage = () => {
    return (
        <>
            <Header />
            <LenderHeroSection />
            <PartnerSection/>
            <LenderFormSection/>
            <Footer />
        </>
    )
}

export default LenderPage;